import React from 'react';
// import { css, cx } from 'emotion';
import { css } from "@emotion/core";
import { standardTransitionDuration, standardTransitionTimingFunction } from '../../Styles/animation';
import colors from '../../Styles/colors';
import styled from "@emotion/styled";

const rv2wrapper = css`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  `;
const rv2 = css`
  width: 66px;
  height: 66px;
  fill: #fff;
  opacity: 0.5;
  `;
const rv3circle = css`
  stroke: #ffffff;
  stroke-width: 2px;
  fill: rgba(0, 0, 0, 0.8);
  transition: fill,stroke;
  transition-duration: ${standardTransitionDuration};
  transition-timing-function: ${standardTransitionTimingFunction};
  `;

export const Rv3triangle = styled('path')`
  fill: #ffffff;
  transition: fill;
  transition-duration: ${standardTransitionDuration};
  transition-timing-function: ${standardTransitionTimingFunction};
`;

const rv3 = css`
  z-index: 3;
  display: inline-block;
  
  &:hover > ${Rv3triangle} {
    fill: ${colors.accent};
  }
  
  .parasol-container:not(.animating) .video-teaser-wrapper.hover & ${Rv3triangle} {
    fill: ${colors.accent};
  }
  
  .parasol-container:not(.animating) .show-teaser-wrapper.hover & ${Rv3triangle} {
    fill: ${colors.accent};
  }
`;

export class PBSPlayButton extends React.Component {
  render() {
    return <div className={rv2wrapper}>
      <svg xmlns="http://www.w3.org/2000/svg"
        className={rv2} viewBox="0 0 240 240"
        focusable="false">
        <path d="M62.8,199.5c-1,0.8-2.4,0.6-3.3-0.4c-0.4-0.5-0.6-1.1-0.5-1.8V42.6c-0.2-1.3,0.7-2.4,1.9-2.6c0.7-0.1,1.3,0.1,1.9,0.4l154.7,77.7c2.1,1.1,2.1,2.8,0,3.8L62.8,199.5z"/>
      </svg>
    </div>;
  }
}

export class PlayButton extends React.Component {
  // CSS Properties hard-coded to .circle.animate for <IE11 support
  render() {
    return (
      <svg className={this.props.className} css={rv3} viewBox="0 0 33 33" xmlns="http://www.w3.org/2000/svg" width="75" height="75">
        <circle css={rv3circle} cx="17" cy="17" r="15" />
        <Rv3triangle d="M12 10 v13.6 l11.8 -7z"/>
      </svg>
    );
  }
}